export default {
  PENDING: 1,
  ACKNOWLEDGED: 2,
  APPEALED: 3,
} as const
